module.exports = __webpack_public_path__ + "img/icon_sectionOpen-sp.db67d81.svg";